module.exports = __webpack_public_path__ + "img/banner-1.72f3d0fc.jpg";